import { Alert } from "@/components/Alert"
import { FormattedMessage } from "react-intl"

export const Receive = ({ title, confirmation }: { title?: string; confirmation?: number }) => {
  return (
    <div className="received">
      <h1 className="uppercase">{title ?? "Received Crypto"}</h1>
      <p className="mb-[30px]">
        <FormattedMessage id="blockchain" /> {confirmation ?? 0}
      </p>
      <Alert>
        <div className="font-normal">
          <FormattedMessage id="received" values={{ strong: (chunk) => <strong>{chunk}</strong> }} />
          <p className="my-2.5">
            <FormattedMessage id="as-soon" />
          </p>
          <p>
            <FormattedMessage id="working-hours" />
          </p>
          <p className="my-2.5">
            <div>
              <FormattedMessage id="status_monday" values={{ from: "07:00", to: "10:00" }} />
            </div>
            <div>
              <FormattedMessage id="weekend" values={{ from: "08:00", to: "09:00" }} />
            </div>
          </p>
          <p>
            <FormattedMessage id="if-you-any" /> &nbsp;
            <a className="text-main-main" href="mailto:support@tranzbase.com">
              support@tranzbase.com
            </a>
          </p>
        </div>
      </Alert>
    </div>
  )
}
